import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../ActionTypes';
import {
  createStripeAccountService,
  stripeFeeCalculationService,
  stripePaymentCheckoutService
} from '../../services/stripServices';
function* createStripAccount(action: any): any {
  try {
    const response = yield call(createStripeAccountService, action.payload);
    if (response?.status === 201) {
      yield put({ type: type.CREATE_STRIPE_ACCOUNT_SUCCESS, data: response.data });
    } else {
      yield put({ type: type.CREATE_STRIPE_ACCOUNT_FAILURE, error: response?.data });
    }
  } catch (e: any) {
    yield put({ type: type.CREATE_STRIPE_ACCOUNT_FAILURE, error: e.error });
  }
}
function* stripeFeeCalculation(action: any): any {
  try {
    const response = yield call(stripeFeeCalculationService, action.payload);
    if (response?.status === 200) {
      yield put({ type: type.STRIPE_FEE_SUCCESS, data: response.data });
    } else {
      yield put({ type: type.STRIPE_FEE_FAILURE, error: response?.data });
    }
  } catch (e: any) {
    yield put({ type: type.STRIPE_FEE_FAILURE, error: e.error });
  }
}
function* stripePaymentCheckout(action: any): any {
  try {
    const response = yield call(stripePaymentCheckoutService, action.payload);
    if (response?.status === 201) {
      yield put({ type: type.STRIPE_PAYMENT_CHECKOUT_SUCCESS, data: response.data });
    } else {
      yield put({ type: type.STRIPE_PAYMENT_CHECKOUT_FAILURE, error: response?.data[0] });
    }
  } catch (e: any) {
    yield put({ type: type.STRIPE_PAYMENT_CHECKOUT_FAILURE, error: e.error });
  }
}
function* stripPaymentSaga() {
  yield takeEvery(type.CREATE_STRIPE_ACCOUNT_REQUEST, createStripAccount);
  yield takeEvery(type.STRIPE_FEE_REQUEST, stripeFeeCalculation);
  yield takeEvery(type.STRIPE_PAYMENT_CHECKOUT_REQUEST, stripePaymentCheckout);
}

export default stripPaymentSaga;
